import { LogicBlock } from './logic-block.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { BoVisitor } from '../../bos/bo-visitor.js'
import { Expression } from '../../data/text-or-code.js'

@jsonClass('DisableBlock')
export class DisableBlock extends LogicBlock {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Disabled',
		codeLanguage: 'ts',
		tsReturnType: () => 'any',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
		tooltip: () => ({
			text: `Use $disabled to access current disabled state, to e.g.<ul>
				<li>conditionally disable if already disabled or age &lt;18: $disabled || person.age &lt; 18</li>
				<li>conditionally enable if age &gte;18: $disabled && person.age &lt; 18</li>
				</ul>`,
			acceptHtml: true,
		}),
	})
	disabledCode = new Expression('true')

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 2,
		label: 'Keep disabled if already disabled',
	})
	keepDisabled = true

	constructor(init: Partial<DisableBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorTitle() {
		const trimmedCode = this.disabledCode.content.trim()
		if (trimmedCode == 'true') return 'Disable'
		if (trimmedCode == 'false') return 'Enable'
		return `Disable/Enable`
	}

	visitThisWithBoVisitor(
		visitor: BoVisitor,
		pathPrefix: (string | number)[],
	): void {
		this.visitCodePropertyWithBoVisitor(
			visitor,
			pathPrefix,
			DisableBlock,
			'disabledCode',
		)
	}

	getEditorCategory(): string {
		return 'Logic'
	}
}
